import {
  RoiAggregatesAppointmentsCompleted,
  RoiAggregatesLeadsContacted,
  RoiAggregatesPatientsScheduled,
  RoiAggregatesResp,
} from '@weave/schema-gen-ts/dist/schemas/analytics-reporting/analytics_gateway/analytics_gateway.pb';
import { demoDataUtils } from '../../../utils';

export const messagingOverviewDemoData = (locationIds: string[]): RoiAggregatesResp => {
  const leadsContacted: RoiAggregatesLeadsContacted = {
    existingPatientsCounts: demoDataUtils.generateRandomInt(1, 500),
    newPatientsCounts: demoDataUtils.generateRandomInt(1, 500),
    unscheduledPatientsCounts: demoDataUtils.generateRandomInt(1, 500),
  };
  const totalPatients =
    (leadsContacted.existingPatientsCounts || 0) +
    (leadsContacted.newPatientsCounts || 0) +
    (leadsContacted.unscheduledPatientsCounts || 0);

  const patientScheduled: RoiAggregatesPatientsScheduled = {
    existingPatientsCounts: demoDataUtils.generateRandomInt(1, leadsContacted.existingPatientsCounts),
    newPatientsCounts: demoDataUtils.generateRandomInt(1, leadsContacted.newPatientsCounts),
  };

  const appointmentsCompleted: RoiAggregatesAppointmentsCompleted = {
    existingPatientsApptsCounts: demoDataUtils.generateRandomInt(1, patientScheduled.existingPatientsCounts),
    newPatientsApptsCounts: demoDataUtils.generateRandomInt(1, patientScheduled.newPatientsCounts),
  };

  return {
    data: locationIds.map((locationId) => ({
      locationId: locationId,
      leadsContacted: {
        ...leadsContacted,
        smsCount: totalPatients + demoDataUtils.generateRandomInt(1, 200),
      },
      patientsScheduled: {
        ...patientScheduled,
        appointmentsCount:
          (patientScheduled.existingPatientsCounts || 0) +
          (patientScheduled.newPatientsCounts || 0) +
          demoDataUtils.generateRandomInt(1, 20),
      },
      appointmentsCompleted: {
        ...appointmentsCompleted,
        appointmentsCount:
          (appointmentsCompleted.existingPatientsApptsCounts || 0) +
          (appointmentsCompleted.newPatientsApptsCounts || 0),
      },
    })),
    message: '',
  };
};
